module.exports = __webpack_public_path__ + "img/sample1.9d0eb8ec.jpg";